import { eventStreamService } from 'core-roblox-utilities';
import { parseEventParams } from '../utils/parsingUtils';

const {
  eventTypes: { pageLoad, formInteraction }
} = eventStreamService;

export const eventType = {
  gameImpressions: 'gameImpressions',
  gameDetailReferral: 'gameDetailReferral',
  sortDetailReferral: 'sortDetailReferral'
} as const;

export const pageContext = {
  searchPage: 'searchPage',
  sortDetailPage: 'sortDetailPage',
  gameDetailPage: 'gameDetailPage',
  gamesPage: 'gamesPage',
  homePage: 'homePage'
} as const;

export const sessionStorageKey = {
  homePageSessionInfo: 'homePageSessionInfo',
  gameSearchSessionInfo: 'gameSearchSessionInfo'
} as const;

export type TEvent = [
  { name: string; type: string; context: string },
  Record<string, string | number>
];
export type TEventType = keyof typeof eventType;
export type TPageContext = keyof typeof pageContext;

export type TGridGameImpressions = {
  rootPlaceIds: number[];
  absPositions: number[];
  adsPositions: number[];
  suggestionKwd?: string;
  suggestionReplacedKwd?: string;
  suggestionCorrectedKwd?: string;
  suggestionAlgorithm?: string;
  algorithm?: string;
  gameSearchSessionInfo?: string;
  homePageSessionInfo?: string;
  emphasisFlag: boolean;
  page: typeof pageContext.searchPage | typeof pageContext.sortDetailPage;
};

export type TCarouselGameImpressions = {
  rootPlaceIds: number[];
  absPositions: number[];
  sortPos: number;
  gameSetTypeId?: number;
  gameSetTargetId?: number;
  page:
    | typeof pageContext.sortDetailPage
    | typeof pageContext.homePage
    | typeof pageContext.gamesPage;
};

export type TGameImpressions = TCarouselGameImpressions | TGridGameImpressions;

export type TSortDetailReferral =
  | {
      position: number;
      sortId: number;
      homePageSessionInfo: string;
      page: typeof pageContext.homePage;
    }
  | Record<string, never>;

export type TGameDetailReferral =
  | {
      placeId: number;
      isAd: boolean;
      position: number;
      numberOfLoadedTiles?: number;
      gameSetTargetId?: number;
      gameSearchSessionInfo?: string;
      homePageSessionInfo?: string;
      page:
        | typeof pageContext.searchPage
        | typeof pageContext.sortDetailPage
        | typeof pageContext.homePage;
    }
  | Record<string, never>;

export default {
  gameImpressions: ({ ...params }: TGameImpressions): TEvent => [
    {
      name: eventType.gameImpressions,
      type: eventType.gameImpressions,
      context: formInteraction
    },
    parseEventParams({
      ...params
    })
  ],
  gameDetailReferral: (params: TGameDetailReferral = {}): TEvent => [
    {
      name: eventType.gameDetailReferral,
      type: eventType.gameDetailReferral,
      context: pageLoad
    },
    parseEventParams({ ...params })
  ],
  sortDetailReferral: (params: TSortDetailReferral = {}): TEvent => [
    {
      name: eventType.sortDetailReferral,
      type: eventType.sortDetailReferral,
      context: pageLoad
    },
    parseEventParams({
      ...params
    })
  ]
};
